<template>
    <div class="delete-files dialog-wraper">
        <p><span>{{confirmInfo}}<b v-if="dialogData.filename">「{{dialogData.filename}}」</b></span></p>
        <div class="dialog-foot">
            <el-button v-if="!dialogData.nocancel" size="mini" @click="doclose" v-cloak>{{$t('Cancel')}}</el-button><el-button :loading="doing" @click="confirm" :type="dialogData.safe ? 'primary' : 'danger'" size="mini" v-cloak>{{dialogData.confirmtxt || $t('Confirm')}}</el-button>
        </div>
    </div>
</template>

<script>
import { mapState,mapMutations,mapActions} from 'vuex';
export default {
    computed:{
        ...mapState([
            'smodule',
            'group',
            'confirmInfo',
            'action',
            'mutation',
            'dialogData'
        ]),
        ...mapState('index',[
            'doing'
        ])
    },
    methods:{
        ...mapActions([
            'close'
        ]),
        doclose(){
            this.dialogData.close ?
                this.dialogData.close() : this.close()
        },
        confirm(){
            this.action ? 
                this.smodule ? 
                    this.$store.dispatch(`${this.smodule}/${this.action}`,this.dialogData.paload) : 
                this.$store.dispatch(this.action,this.dialogData.paload) : 
            this.smodule ? 
                this.$store.commit(`${this.smodule}/${this.mutation}`) :
                this.$store.commit(this.mutation) 
            
        }
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/dialog/Confirm.vue